<template>
  <O3D layout="overall">
    <O3D v-for="fruit in fruits" :key="fruit._id" :layout="fruit.name">
      <Fruit :name="fruit.name" :url="fruit.url"></Fruit>
    </O3D>
  </O3D>
</template>

<script>
import { O3DG2 } from '../../Reusable/O3DG2'
import { list as fruits } from './models/glb.js'
import { Vector3 } from 'three'
export default {
  mixins: [O3DG2],
  data () {
    return {
      layouts: {},
      fruits: []
    }
  },
  methods: {
    async setup () {
      let typesOfFruit = [
        {
          'type': 'pineapple',
          'scale': 1
        },
        {
          'type': 'tomato',
          'scale': 0.03
        },
        {
          'type': 'strawberry',
          'scale': 0.2
        },
        {
          'type': 'pear',
          'scale': 1
        },
        {
          'type': 'orange',
          'scale': 1
        },
        {
          'type': 'lemon',
          'scale': 4
        },
        {
          'type': 'grapes',
          'scale': 1
        },
        {
          'type': 'cherry',
          'scale': 1
        },
        {
          'type': 'banana',
          'scale': 0.007
        },
        {
          'type': 'apple',
          'scale': 0.07
        }
      ]
      let v3FruitTemp = new Vector3()
      this.fruits = fruits.map((e, fi) => {
        let found = typesOfFruit.find(t => t.type === e.name) || { scale: 1 }
        let radius = 25
        let fnMax = fruits.length
        let v3 = v3FruitTemp.clone().setFromCylindricalCoords(radius, fi / fnMax * Math.PI * 2.0, 5)
        this.layouts[e.name] = {
          sx: found.scale,
          sy: found.scale,
          sz: found.scale,
          px: v3.x,
          py: v3.y,
          pz: v3.z,
          ry: 0
        }
        this.onLoop(() => {
          this.layouts[e.name].ry += 0.01
        })
        return {
          ...found,
          ...e
        }
      })
      this.layouts.overall = {
        ry: 0
      }
      this.onLoop(() => {
        this.layouts.overall.ry += 0.003
      })
      // console.log(this.fruits)
      // await GlowBall.makeScene({ o3d: this.o3d, clean: this.onClean, camera: this.ctx.camera, loop: this.onLoop })
    }
  },
  mounted () {
    this.setup()
  }
}
</script>

<style>

</style>